<template>
  <NavbarApp />
  <div class="news-page">
    <h1 class="page-title">{{ $t('news.pageTitle') }}</h1>
    <div class="articles-grid">
      <div v-for="article in articles" :key="article.id" class="article-card">
        <!-- Move article-footer outside router-link -->
        <router-link :to="{ name: 'ArticleDetail', params: { id: article.id } }" class="article-link">
          <img :src="article.image" :alt="article.title" class="article-image" />
          <div class="article-content">
            <h2 class="article-title">{{ article.title }}</h2>           
            <p class="article-date">{{ formatDate(article.date) }}</p>
            <p class="article-excerpt">{{ article.excerpt }}</p>
            <span class="read-more">{{ $t('news.readMore') }}</span>
          </div>
        </router-link>
        <!-- Separate share buttons container  
        <div class="article-footer">
          <div class="share-buttons">
              <button @click="shareOnFacebook(article)" class="share-button facebook">
    <i class="fab fa-facebook-f"></i>
  </button>
  <button @click="shareOnLinkedIn(article)" class="share-button linkedin">
    <i class="fab fa-linkedin-in"></i>
  </button>
  <button @click="shareOnWhatsApp(article)" class="share-button whatsapp">
    <i class="fab fa-whatsapp"></i>
  </button>
          </div>
        </div>-->
      </div>
    </div>
  </div>
  <Section4 />
</template>

<script>
import articlesData from '@/database/news.json'; // Adjust path if needed
import NavbarApp from '../components/HomePage/navbar-law.vue';
import Section4 from '../components/HomePage/section-4.vue';

export default {
  name: 'NewsPage',
  components: {
    NavbarApp,
    Section4,
  },
  data() {
    return {
      articles: articlesData,
    };
  },
  methods: {
    formatDate(dateString) {
      // Use the current locale for date formatting
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(this.$i18n.locale, options); // Dynamically use current locale
    },
    
   shareOnFacebook(article) {
    const url = `${window.location.origin}/article/${article.id}`;
    const title = encodeURIComponent(article.title);
    const image = encodeURIComponent(`${window.location.origin}${article.image}`);
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${title}&picture=${image}`;
    this.openShareWindow(shareUrl, 'FacebookShare');
  },

  shareOnLinkedIn(article) {
    const url = `${window.location.origin}/article/${article.id}`;
    const title = encodeURIComponent(article.title);
    const image = encodeURIComponent(`${window.location.origin}${article.image}`);
    const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}&title=${title}&summary=${encodeURIComponent(article.excerpt || '')}&source=${encodeURIComponent(window.location.origin)}&image=${image}`;
    this.openShareWindow(shareUrl, 'LinkedInShare');
  },

  shareOnWhatsApp(article) {
    const url = `${window.location.origin}/article/${article.id}`;
    const title = encodeURIComponent(article.title);
    const image = encodeURIComponent(`${window.location.origin}${article.image}`);
    const text = `${title}\n\n${image}\n\n${url}`;
    const shareUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;
    this.openShareWindow(shareUrl, 'WhatsAppShare');
  },

    openShareWindow(url, windowName) {
      const width = 626;
      const height = 436;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;
      
      window.open(
        url,
        windowName,
        `width=${width},height=${height},left=${left},top=${top},toolbar=0,menubar=0,location=0,status=0`
      );
    }
  }
};
</script>

<style scoped>
/* Your existing styles are good and will remain unchanged. */
/* Just ensuring they are included here for completeness */
.news-page {
  padding: 40px 20px;
  max-width: 1200px;
  margin: 0 auto;
  color: #333;
}

.page-title {
  text-align: center;
  font-size: 2.8rem;
  color: #333;
  margin-bottom: 50px;
  position: relative;
  padding-bottom: 15px;
}

.page-title::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background-color: #bbd55a;
  border-radius: 2px;
}

.share-button.whatsapp {
  background-color: #25D366;
  color: white;
}

.share-button.whatsapp:hover {
  transform: scale(1.1);
  background-color: #20bd5a;
}

.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.article-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
}

.article-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.article-link {
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  height: 100%; /* Ensure link fills card */
}

.article-image {
  width: 100%;
  height: 200px; /* Fixed height for consistency */
  object-fit: cover; /* Cover the area, crop if necessary */
  display: block;
}

.article-content {
  padding: 20px;
  flex-grow: 1; /* Allows content to expand and push "Read More" to bottom */
  display: flex;
  flex-direction: column;
   text-align: justify;
  text-justify: inter-word;
}

.article-title {
  font-size: 1.5rem;
  color: #333;
  margin-top: 0;
  margin-bottom: 10px;
  line-height: 1.3;
}

.article-date {
  font-size: 0.9rem;
  color: #777;
  margin-bottom: 15px;
}

.article-excerpt {
  font-size: 1rem;
  color: #555;
  line-height: 1.6;
  flex-grow: 1; /* Allows excerpt to take available space */
  margin-bottom: 20px; /* Space before read more */
}

.read-more {
  display: inline-block;
  color: #bbd55a;
  font-weight: 400;
  text-decoration: none;
  transition: color 0.3s ease;
  align-self: flex-start; /* Align to the start of the flex container */
}

.read-more:hover {
  color: #bbd55a;
  text-decoration: underline;
}

/* Add this to your existing <style> section */
.article-footer {
  padding: 0 20px 20px;
  display: flex;
  justify-content: flex-end;
  margin-top: -20px; /* Adjust spacing with content above */
}
.footnote-list {
  padding: 0 20px 20px;
  display: flex;
  justify-content: flex-end;
  margin-top: -20px; /* Adjust spacing with content above */
}
.share-buttons {
  display: flex;
  gap: 10px;
}

.share-button {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.share-button:hover {
  transform: scale(1.1);
}

.share-button.facebook {
  background-color: #1877f2;
  color: white;
}

.share-button.linkedin {
  background-color: #0077b5;
  color: white;
}

/* Add this in your <head> section of index.html for Font Awesome icons */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css');
</style>